import React from "react";
import styled from "styled-components";
import { Link as ThirdPartyLink } from "react-router-dom";
import { Styles } from "../config";
import Typography from "./Typography";

const Anchor = styled.div`
  & > * {
    transition: all 300ms ease-in-out;
  }

  & > *:hover {
    color: ${Styles.Color?.secondary};
  }
`;

const Link = (props) => {
  const { variant } = props;
  return (
    <ThirdPartyLink className={variant || "t1"} {...props}>
      <Anchor>
        <Typography {...props}>{props.children}</Typography>
      </Anchor>
    </ThirdPartyLink>
  );
};

export default Link;
